import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { Megaphone, X, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AnnouncementBar() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/announcements`)
      .then((r) => setItems(r.data || []))
      .catch(() => {});
  }, []);

  const a = items[0];

  return (
    <AnimatePresence>
      {a && !dismissed && (
        <motion.aside
          data-testid="announcement-card"
          initial={{ opacity: 0, y: 40, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ duration: 0.5, delay: 2, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 z-50 max-w-sm rounded-xl bg-[#263562] text-white p-5 shadow-[0_25px_60px_-15px_rgba(27,38,71,0.6)] border border-white/10"
        >
          <button
            data-testid="announcement-close"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss announcement"
            className="absolute top-3 right-3 text-white/60 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-2 mb-2">
            <Megaphone className="w-4 h-4 text-[#3AB0E1]" />
            <span className="font-mono-tech text-[9px] uppercase tracking-[0.25em] text-[#3AB0E1]">
              Announcement
            </span>
          </div>
          <h4 className="font-display font-semibold text-lg leading-snug">{a.title}</h4>
          {a.body && <p className="mt-1.5 text-sm text-slate-300 font-light leading-relaxed">{a.body}</p>}
          {a.link && (
            <a
              data-testid="announcement-link"
              href={a.link}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-1.5 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#3AB0E1] hover:text-white transition-colors"
            >
              Learn more <ArrowUpRight className="w-3 h-3" />
            </a>
          )}
        </motion.aside>
      )}
    </AnimatePresence>
  );
}
